import { useI18n } from "@/i18n/I18nProvider";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { lang, setLang, t } = useI18n();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full border-0 bg-transparent hover:bg-accent/50 text-[12px] font-medium text-foreground/80 hover:text-foreground transition-all outline-none focus-visible:ring-1 focus-visible:ring-primary shadow-none cursor-pointer"
        aria-label={t.nav.language}
      >
        <Globe className="h-4 w-4" />
        <span className={compact ? "sr-only sm:not-sr-only" : ""}>{lang.toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        <DropdownMenuItem onClick={() => setLang("en")} className={lang === "en" ? "font-semibold" : ""}>
          🇺🇸 English
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLang("es")} className={lang === "es" ? "font-semibold" : ""}>
          🇪🇸 Español
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
